import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import { Table } from "../../../components/Table";
import { TableTypes } from "../../../components/Table/Table.types";
import { UserPermissions } from "../../../enums";
import { Api } from "../../../services/api";
import { Company } from "../../../services/api/types/Companies";
import { filterUniqueKeys } from "../../../services/utils/filterUniqueKeys";
import { handleAxiosError } from "../../../services/utils/handleAxiosError";
import { useAppSelector } from "../../../store/hooks";
import { defaultDropDownFilters, getColumns } from "./columnData";
import { Container } from "../Admin.styles";

export const Companies = () => {
  const history = useHistory();
  const userPermissions = useAppSelector(state => state.auth.user.permissions);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [tableData, setTableData] = useState<Array<Company>>([]);
  const [dropDownFilters, setDropFilters] = useState<any>(null);

  useEffect(() => {
    fetchCompanies();
  }, []);

  const fetchCompanies = async () => {
    setIsLoading(true);

    try {
      const response = await Api.companies.get();
      const newDropDownFilters = filterUniqueKeys(
        response.data.companies,
        defaultDropDownFilters,
        Object.keys(defaultDropDownFilters)
      );

      setDropFilters(newDropDownFilters);
      setTableData(response.data.companies);
    } catch (error) {
      console.error("Companies fetch:", error);
      handleAxiosError(error);
    }

    setIsLoading(false);
  };

  let handleAddCompany;
  if (userPermissions.includes(UserPermissions.TeamAddTeam)) {
    handleAddCompany = () => {
      const currentLocation = history.location;
      currentLocation.pathname = `${currentLocation.pathname}/add`;
      history.push(currentLocation);
    };
  }

  return (
    <>
      <Container>
        <Table
          searchable
          title={TableTypes.Companies}
          tableType={TableTypes.Companies}
          isLoading={isLoading}
          defaultRows={20}
          columns={getColumns()}
          rowsPerPage={[10, 20, 35, 50]}
          data={tableData}
          dropDownFilters={dropDownFilters}
          handleAddButton={handleAddCompany}
        />
      </Container>
    </>
  );
};
